import React, { Component } from "react";
import GalleryOutfitList from "container/searchForUser/GalleryOutfitList";
import { withStore } from "store/storeHandler";
import { withToken } from "lib/forceTokenRenewComponent";

class GalleryOutfitListPanel extends Component {
  initGalleryList = async () => {
    const { GalleryActions, AppErrorActions, getIdTokenWT } = this.props;
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await GalleryActions.initList(idToken);
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  getGalleryOutfitList = async () => {
    const { GalleryActions, AppErrorActions, getIdTokenWT } = this.props;
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;
    try {
      await GalleryActions.requestNextList(idToken);
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  render() {
    const { outfitList, isLoading, isEnd } = this.props;

    return (
      <GalleryOutfitList
        getList={this.getGalleryOutfitList}
        outfitList={outfitList}
        isLoading={isLoading}
        isEnd={isEnd}
      />
    );
  }

  componentDidMount() {
    this.initGalleryList();
  }
}

export default withToken(
  withStore({
    stateMap: {
      gallery: ["outfitList", "isLoading", "isEnd"]
    },
    dispatchMap: ["gallery", "appError"]
  })(GalleryOutfitListPanel)
);
